import React, { useEffect, Suspense, lazy } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { HeroSection } from './components/HeroSection';
import { initMetaPixel } from './lib/metaPixel';
import { initClarity } from './lib/clarity';
const ForWhomSection = lazy(() => import('./components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const PainPointsSection = lazy(() => import('./components/PainPointsSection').then(m => ({
  default: m.PainPointsSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const BenefitsSection = lazy(() => import('./components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ModulesSection = lazy(() => import('./components/ModulesSection').then(m => ({
  default: m.ModulesSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTASection = lazy(() => import('./components/FinalCTASection').then(m => ({
  default: m.FinalCTASection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  useEffect(() => {
    initMetaPixel();
    initClarity();
  }, []);
  return <div className="min-h-screen bg-black" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1894598721199176&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <StickyAlertBar data-id="element-3" />
      <HeroSection data-id="element-4" />
      <Suspense fallback={null} data-id="element-5">
        <TestimonialsSection data-id="element-6" />
        <ForWhomSection data-id="element-7" />
        <PainPointsSection data-id="element-8" />
        <SolutionSection data-id="element-9" />
        <BenefitsSection data-id="element-10" />
        <ModulesSection data-id="element-11" />
        <BonusSection data-id="element-12" />
        <PricingSection data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <FAQSection data-id="element-15" />
        <FinalCTASection data-id="element-16" />
        <Footer data-id="element-17" />
      </Suspense>
      <StickyMobileCTA data-id="element-18" />
    </div>;
}